<button class="btn px-3 py-2 text-nowrap" [attr.data-cy]="'moreMenuItem-' + id">
	<ng-content></ng-content>
</button>
